import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface ReopenConfirmDialogProps {
  open: boolean;
  appraiseeName: string;
  assignmentId: string;
  isReopening: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function ReopenConfirmDialog({
  open,
  appraiseeName,
  assignmentId,
  isReopening,
  onClose,
  onConfirm,
}: ReopenConfirmDialogProps) {
  // Reopen is non-destructive: it keeps all existing content and the assigned author,
  // returns the status to Started, gives a fresh 14-day due date, and re-sends the
  // assignment email. The dialog stays locked while the request runs.
  return (
    <Dialog
      open={open}
      onClose={isReopening ? undefined : onClose}
      aria-labelledby="reopen-job-end-title"
    >
      <DialogTitle id="reopen-job-end-title">Reopen Job End?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to reopen the Job End for {appraiseeName} for assignment{' '}
          {assignmentId}? The existing form content will be preserved and the Collator will be
          notified.
        </DialogContentText>
        {isReopening && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 2 }} aria-live="polite">
            <CircularProgress size={20} aria-hidden />
            <DialogContentText sx={{ m: 0 }}>
              This can take a few seconds while the Job End is reopened.
            </DialogContentText>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isReopening}>
          No
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="secondary"
          disabled={isReopening}
          aria-busy={isReopening}
          startIcon={isReopening ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {isReopening ? 'Reopening Job End…' : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ReopenConfirmDialog;
